"use strict";

import React from 'react';

import { BootButton, CloseButton } from 'generics/buttons';
import { IconGlyphicon, IconFontAwesome } from 'generics/icons';
import { spawnDialogWindow } from 'components/dialogHolder';


export function spawnThemeTestModal()  {
  spawnDialogWindow(ViewThemeTestDialog, {});
}


class ViewThemeTestDialog extends React.Component  {
  constructor(props)  {
    super(props);

    this.classes = [ "default", "primary", "success", "info", "warning", "danger" ];

  }


  onBackdropTouch()  {
    this.props.removeModal();
  }


  render()  {
    const texts  = this.classes.map(
        (className)  => (<b key={className} className={"text-"+className}>&nbsp;text-{className}&nbsp;</b>)
      );
    const alerts  = this.classes.map(
        (className)  => (<div key={className}
                              className={"alert alert-"+className}
                              style={{display:"inline-block"}}>&nbsp;alert-{className}&nbsp;</div>)
      );
    const buttons  = this.classes.map(
              (className)  => (<BootButton key={className} variant={className}>{className}</BootButton>)
            );
    const buttonsAct  = this.classes.map(
              (className)  => (<BootButton key={className} variant={className} active>{className} active</BootButton>)
            );
    const buttonsDis  = this.classes.map(
              (className)  => (<BootButton key={className} variant={className} disabled>{className} disabled</BootButton>)
            );
    const panels  = this.classes.map(
        (className)  => (<div key={className}
                              className={"panel panel-"+className+" panel-sm"}
                              style={{display:"inline-block"}}>
                              <div className="panel-heading">&nbsp;panel-{className}&nbsp;</div>
                          </div>)
      );


    return (
        <div className="panel panel-primary panel-sm view-theme-test-dialog">
          <div className="panel-heading">
            <IconFontAwesome type="gear" fixedWidth />&nbsp;Theme Testing
            <CloseButton onClick={this.props.removeModal} />
          </div>

          <div className="panel-body">
            <div className="text-center">{texts}</div>
            <div className="text-center">{alerts}</div>
            <div className="text-center">{buttons}</div>
            <div className="text-center">{buttonsAct}</div>
            <div className="text-center">{buttonsDis}</div>
            <div className="text-center">{panels}</div>
          </div>
        </div>
    );
  }


}

